export function authHeader() {
    // return authorization header with jwt token
    let state = JSON.parse(localStorage.getItem('state'));

    if (state && state.auth && state.auth.token) {
        return { 'Authorization': 'Bearer ' + state.auth.token , 'Content-Type': 'application/json'};
    } else {
        return {};
    }
}